import { postData, getData } from "../api/protectedApi";

export const callDataByEndpoint = async (endpointOrOptions, options = {}) => {
  let endpoint = "";
  let config = {};

  if (typeof endpointOrOptions === "string") {
    endpoint = endpointOrOptions;
    config = options || {};
  } else if (endpointOrOptions && typeof endpointOrOptions === "object") {
    endpoint = endpointOrOptions.endpoint;
    config = endpointOrOptions;
  }

  if (!endpoint) {
    console.error("callDataByEndpoint error: No endpoint provided.");
    return { success: false, data: [], count: 0, error: new Error("Endpoint is required") };
  }

  const {
    page,
    limit = 10,
    skip: customSkip,
    params = {},
    method = "POST",
    setData,
    setTotalCount,
    setIsLoading,
    loadingDelay = 300,
  } = config;

  if (typeof setIsLoading === "function") {
    setIsLoading(true);
  }

  // Prepare payload parameters
  const payload = { ...params };
  if (page !== undefined && page !== null) {
    const skipVal = customSkip !== undefined ? customSkip : (page - 1) * limit;
    payload.skip = skipVal.toString();
    payload.limit = limit.toString();
  }

  try {
    let res;
    if (method.toUpperCase() === "GET") {
      res = await getData(endpoint, payload);
    } else {
      res = await postData(endpoint, payload);
    }

    const dataList = res?.data?.data && Array.isArray(res.data.data) ? res.data.data : [];
    const count = res?.data?.count || dataList.length;

    if (typeof setData === "function") {
      setData(dataList);
    }
    if (typeof setTotalCount === "function") {
      setTotalCount(count);
    }

    return {
      success: true,
      data: dataList,
      count,
      raw: res,
    };
  } catch (err) {
    console.error(`Error calling endpoint [${endpoint}]:`, err);

    if (typeof setData === "function") {
      setData([]);
    }
    if (typeof setTotalCount === "function") {
      setTotalCount(0);
    }

    return {
      success: false,
      data: [],
      count: 0,
      error: err,
    };
  } finally {
    if (typeof setIsLoading === "function") {
      if (loadingDelay > 0) {
        setTimeout(() => setIsLoading(false), loadingDelay);
      } else {
        setIsLoading(false);
      }
    }
  }
};

// Aliases for developer convenience
export const fetchDataByEndpoint = callDataByEndpoint;
export const callData = callDataByEndpoint;
export const fetchData = callDataByEndpoint;

export default callDataByEndpoint;
